<div [formGroup]="parentFormGroup">
    <!-- For retro compatibility -->
    <!-- <app-audio-transcription
            #audioTranscriptionComponent
            *ngIf="audioTranscription"
            [config]="audioTranscription"
            (transcriptionEndedEvent)="insertString($event)"
            (transcriptionStartedEvent)="transcriptionStarted()"></app-audio-transcription> -->
        <app-audio-transcription-v2
                #audioTranscriptionComponentV2
        [config]="audioTranscriptionConfig"
        *ngIf="audioTranscriptionConfig"
        [existingTranscription]="parentFormGroup.get(parentFormControlName).value"
        (transcriptionEndedEvent)="transcriptionEnded($event)"
        (transcriptionImprovementEndedEvent)="transcriptionImprovementEnded($event)"
        (transcriptionStartedEvent)="transcriptionStarted()"></app-audio-transcription-v2>

    <quill-editor #editor class="content-editor {{display}}"
                  (onEditorCreated)="onEditorCreated($event); setFocus()"
                  [placeholder]="''"
                  format="html"
                  [modules]="configuration"
                  [style.flex-direction]="'column'"
                  [style.display]="'flex'"
                  [style.color]="'black'"
                  [sanitize]="false"
                  [formControlName]="parentFormControlName"
                  (onContentChanged)="onContentChange($event)"></quill-editor>
</div>
